// Надёжный unlock через WebAudio. Вызывать внутри клика/тапа перед startCall/acceptCall.
let unlocked = false;

export async function unlockAudio() {
    if (unlocked) return true;
    try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) { unlocked = true; return true; } // старые браузеры — ок
        const ctx = new Ctx();
        const buffer = ctx.createBuffer(1, 1, 22050);
        const src = ctx.createBufferSource();
        src.buffer = buffer;
        src.connect(ctx.destination);
        src.start(0);
        await ctx.resume().catch(() => { });
        // контекст оставляем жить
        unlocked = true;
        console.log('[audio] unlocked via WebAudio');
        return true;
    } catch (e) {
        console.warn('[audio] unlock failed:', e?.name || e);
        return false;
    }
}
